import { httpService, manageFormRequest } from "./httpService";
import { httpConstants } from "../lib/constants";
import axios from "axios";

function getTenantServiceUrl() {
    return process.env.REACT_APP_TENANT_SERVICE_URL;
}

function getUserManagementUrl() {
    return process.env.REACT_APP_USERMANAGEMENT_SERVICE_URL;
}

async function getPermissions() {
    let url = getTenantServiceUrl() + httpConstants.API_END_POINT.GET_USER_PERMISSIONS;
    return httpService(httpConstants.METHOD_TYPE.POST, null, url)
        .then((response) => {
            if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0) return Promise.reject();
            return Promise.resolve(response.responseData);
        })
        .catch(function (err) {
            return Promise.reject(err);
        });
}

async function getMenuOptions() {
    let url = getTenantServiceUrl() + httpConstants.API_END_POINT.GET_SERVICES_MENU;
    return httpService(httpConstants.METHOD_TYPE.POST, null, url)
        .then((response) => {
            if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0) return Promise.reject();
            return Promise.resolve(response.responseData);
        })
        .catch(function (err) {
            return Promise.reject(err);
        });
}

async function getRegions(requestData) {
    let url = getTenantServiceUrl() + httpConstants.API_END_POINT.GET_REGIONS;
    return httpService(httpConstants.METHOD_TYPE.POST, requestData, url)
        .then((response) => {
            if (!response.success || response.responseCode !== 200 || !response.responseData) return Promise.reject();
            return Promise.resolve(response.responseData);
        })
        .catch(function (err) {
            return Promise.reject(err);
        });
}

// async function getUsers(requestData) {
//     let url = getTenantServiceUrl() + httpConstants.API_END_POINT.TENANT_GET_USERS;
//     return httpService(httpConstants.METHOD_TYPE.POST, requestData, url)
//         .then((response) => {
//             if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0) return Promise.reject();
//             return Promise.resolve(response.responseData);
//         })
//         .catch(function (err) {
//             return Promise.reject(err);
//         });
// }
async function getUsers(requestData) {
    let url = getTenantServiceUrl() + httpConstants.API_END_POINT.TENANT_GET_USERS;
    let response = await axios({
        method: "post",
        url: url,
        data: requestData,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
    return response?.data || null;
}
async function addUserByCustomer(requestData) {
    let url = getUserManagementUrl() + httpConstants.API_END_POINT.ADD_USER_BY_CUSTMER;
    let jwtToken = localStorage.getItem("token");

    let response = await axios({
        method: "post",
        url: url,
        data: requestData,
        headers: {
            Authorization: "Bearer " + jwtToken,
        },
    });
    return response.data;
    // return await manageFormRequest(httpConstants.METHOD_TYPE.POST, requestData, url);
}

async function updateUserPermission(requestData) {
    let url = getTenantServiceUrl() + httpConstants.API_END_POINT.UPDATE_USER_PERMISSION;
    return await manageFormRequest(httpConstants.METHOD_TYPE.POST, requestData, url);
}

async function allowTAndCForServices(requestData) {
    let url = getTenantServiceUrl() + httpConstants.API_END_POINT.ALLOW_T_AND_C_FOR_SERVICES;
    return httpService(httpConstants.METHOD_TYPE.POST, requestData, url)
        .then((response) => {
            if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0) return Promise.reject();
            return Promise.resolve(response.responseData);
        })
        .catch(function (err) {
            return Promise.reject(err);
        });
}

async function loginUser(requestData) {
    let url = getUserManagementUrl() + "/login";
    let response = await axios({
        method: "post",
        url: url,
        data: requestData,
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
}

async function forgotSendCode(requestData) {
    let url = getUserManagementUrl() + "/forgot-send-code";
    let response = await axios({
        method: "post",
        url: url,
        data: requestData,
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
}

async function forgotCNFPswd(requestData) {
    let url = getUserManagementUrl() + "/forgot-conf-pass";
    let response = await axios({
        method: "post",
        url: url,
        data: requestData,
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
}

async function confirmSignup(requestData) {
    let url = getUserManagementUrl() + "/confirm-signup";
    let response = await axios({
        method: "post",
        url: url,
        data: requestData,
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
}

async function updateDesignerInfo(requestData) {
    let url = getTenantServiceUrl() + "/update-designer-info";
    let response = await axios({
        method: "post",
        url: url,
        data: requestData,
        headers: { "Content-Type": "application/json" },
    });
    return response.data;
}
async function updateUserDetails(requestData) {
    let url = getUserManagementUrl() + httpConstants.API_END_POINT.UPDATE_USER_DETAILS;
    let jwtToken = localStorage.getItem("token");
    let response = await axios({
        method: "put",
        url: url,
        data: requestData,
        headers: { "Content-Type": "multipart/form-data", Authorization: "Bearer " + jwtToken },
    });
    return response.data;
}
async function createQRCode(requestData) {
    let url = getTenantServiceUrl() + "/create-qr-code";
    let jwtToken = localStorage.getItem("token");
    let response = await axios({
        method: "post",
        url: url,
        data: requestData,
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + jwtToken },
    });
    return response.data;
}
async function sendOTPtoUser(requestData) {
    let url = getUserManagementUrl() + httpConstants.API_END_POINT.SEND_OTP;
    let jwtToken = localStorage.getItem("token");
    let response = await axios({
        method: "post",
        url: url,
        data: requestData,
        headers: { Authorization: "Bearer " + jwtToken },
    });
    return response.data;
}
async function verifyOTP(requestData) {
    let url = getUserManagementUrl() + httpConstants.API_END_POINT.VERIFY_OTP;
    let jwtToken = localStorage.getItem("token");
    let response = await axios({
        method: "post",
        url: url,
        data: requestData,
        headers: { Authorization: "Bearer " + jwtToken },
    });
    return response.data;
}
async function changeTemporaryPassword(payload) {
    const url = `${getUserManagementUrl()}/confirm-user-password`;
    let response = await axios({
        method: "post",
        url: url,
        data: payload,
        headers: {
            "Content-Type": "application/json",
        },
    });
    return response.data;
}
async function deleteUser(requestData) {
    let url = getUserManagementUrl() + httpConstants.API_END_POINT.DELETE_USER;
    let jwtToken = localStorage.getItem("token");
    let response = await axios({
        method: "delete",
        url: url,
        data: requestData,
        headers: { Authorization: "Bearer " + jwtToken },
    });
    return response.data;
}
async function resendInvitation(requestData) {
    let url = getUserManagementUrl() + httpConstants.API_END_POINT.USER_RESEND_INVITATION;
    let jwtToken = localStorage.getItem("token");
    let response = await axios({
        method: "post",
        url: url,
        data: requestData,
        headers: { Authorization: "Bearer " + jwtToken },
    });
    return response.data;
}

const service = {
    getPermissions,
    getMenuOptions,
    getRegions,
    getUsers,
    addUserByCustomer,
    updateUserPermission,
    allowTAndCForServices,
    loginUser,
    forgotSendCode,
    forgotCNFPswd,
    confirmSignup,
    updateDesignerInfo,
    changeTemporaryPassword,
    updateUserDetails,
    deleteUser,
    resendInvitation,
    sendOTPtoUser,
    verifyOTP,
    createQRCode
};

export default service;
